import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { SToastViewport } from '@chargebee/sting-react';
import { ErrorPage } from '@bbkAdminComponents/app-layout/error';
import { DesignerLocaleRouteObserver } from '@bbkAdminComponents/designer/designer-locale-route-observer';
import { InfoModalContainer } from '@bbkAdminComponents/info-dialog';
import { persistor, store } from '@bbkAdminRedux/redux';
import { AdminApp } from '@bbkAdminRouter/admin-app';
import { useDetectIE } from '@bbkAdminUtils/detect-ie';
import { GlobalLogger } from '@bbkAdminUtils/GlobalLogger';
import { createBrowserRouter, RouterProvider } from '@bbkShared/react-router';

import '@chargebee/sting-react/sting-react.css';

const router = createBrowserRouter([
  {
    path: '*',
    errorElement: (
      <ErrorPage message="Something went wrong. Please reload the page and try again." />
    ),
    element: (
      <>
        <DesignerLocaleRouteObserver />
        <InfoModalContainer>
          <AdminApp />
        </InfoModalContainer>
        <SToastViewport position="bottom-right" />
      </>
    ),
  },
]);

export const Main: React.FC = () => {
  const isIE = useDetectIE();

  if (isIE) {
    return (
      <ErrorPage message="Sorry, IE is not supported.  Please try Chrome, Firefox, or Safari" />
    );
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* Preserve synchronous URL updates for controlled tabs: pointer and focus
            must not enqueue the same navigation before the URL commits. */}
        <RouterProvider
          router={router}
          onError={GlobalLogger.error}
          useTransitions={false}
        />
      </PersistGate>
    </Provider>
  );
};
